import Gradient from "./gradient";
import gsap from "gsap";

const gradientColors = ["#f5f5f5", "#f3f3f4", "#e3e3ee", "#cacae5", "#f5f5f5", "#e3e3ee", "#f5f5f5", "#f3f3f4"];

const headerGradient = new Gradient(
	gradientColors,
	110,
	{
		wireframe: false,
	},
	{
		noiseY: 4.47,
		cameraPosition: { x: -0.18, y: -0.62, z: 0.45 },
		autoplay: false,
	}
);

const header = document.querySelector("header");

const canvas = headerGradient.canvas();

canvas.style.position = "absolute";
canvas.style.top = 0;
canvas.style.left = 0;
canvas.style.width = "100%";
canvas.style.zIndex = "3";
canvas.style.height = "600px";

header.prepend(canvas);

const megaMenu = document.querySelector(".salsnes-mega-menu");
const menuTrigger = document.querySelector(".salsnes-mega-menu__toggle");
const navBar = document.querySelector(".salsnes-navigation");
const logo = document.querySelector(".salsnes-logo");
canvas.style.height = megaMenu.getBoundingClientRect().bottom + window.scrollY + "px";

let state = false;

const openMenu = gsap.timeline({
	paused: true,
	reversed: true,
	onStart: () => {
		headerGradient.play();
	},
});

gsap.set(canvas, {
	opacity: 0,
	autoAlpha: 0,
});

gsap.set(megaMenu, {
	opacity: 0,
	autoAlpha: 0,
});

openMenu.to(canvas, {
	opacity: 1,
	autoAlpha: 1,
	duration: 0.35,
	easing: "power1.inOut",
});

openMenu.to(
	megaMenu,
	{
		opacity: 1,
		autoAlpha: 1,
		duration: 0.35,
		easing: "power1.inOut",
	},
	0
);

openMenu.to(
	menuTrigger,
	{
		"--rotation": "45deg",
		"--line-offset": "0%",
		duration: 0.35,
	},
	0
);

const closeMenu = gsap.timeline({
	paused: true,
	reversed: true,
	onStart: () => {
		headerGradient.pause();
	},
});

closeMenu.to(canvas, {
	opacity: 0,
	duration: 0.5,
	autoAlpha: 0,
	easing: "power1.inOut",
});

closeMenu.to(
	megaMenu,
	{
		opacity: 0,
		autoAlpha: 0,
		duration: 0.35,
		easing: "power1.inOut",
	},
	0
);

closeMenu.to(
	menuTrigger,
	{
		"--rotation": "0deg",
		"--line-offset": "150%",
		duration: 0.35,
	},
	0
);

menuTrigger.addEventListener("click", () => {
	state = !state;
	if (state) {
		openMenu.play(0);
		navBar.classList.add("open");
		logo.classList.add("menu-open");
	} else {
		closeMenu.play(0);
		navBar.classList.remove("open");
		logo.classList.remove("menu-open");
	}
});
